import { render } from "./SuscripcionPago.vue?vue&type=template&id=929d6854&scoped=true&ts=true"
import script from "./SuscripcionPago.vue?vue&type=script&lang=ts"
export * from "./SuscripcionPago.vue?vue&type=script&lang=ts"

import "./SuscripcionPago.vue?vue&type=style&index=0&id=929d6854&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929d6854"]])

export default __exports__